import { __decorate, __metadata } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { w } from '@dojo/framework/core/vdom';
import { beforeProperties } from '@dojo/framework/core/decorators/beforeProperties';
import { NumericEntryBase } from './ne-base';
import { NEQuestionPretest } from './ne-pretest';
import { NEQuestionPearsonVue } from './ne-pearsonvue';
import { NEQuestionAudit } from './ne-audit';
import { PearsonVueReview } from './review-pearsonvue';
import { PretestReview } from './review-pretest';
export class NumericEntry extends I18nThemed {
    _propsInited = false;
    render() {
        const { quizstore, quizkind, progression, inreview = false, isaudit = false, hasNextQuestion, onNextQuestion, hasPreviousQuestion, onPreviousQuestion, onFinish, updater, onReview, getQuestions, filterOn, checkFor = () => true, hasNextSection = () => false, hasReviewed } = this.properties;
        const questionProps = {
            quizstore,
            hasNextQuestion,
            onNextQuestion,
            hasPreviousQuestion,
            onPreviousQuestion,
            onFinish,
            updater,
            onReview,
            hasReviewed
        };
        const pearsonvueAudit = (inreview) => inreview
            ? w(PearsonVueReview, {
                quizstore,
                getQuestions,
                onFinish,
                filterOn,
                checkFor,
                onReview,
                isaudit: true,
                localizedBundle: { isPlaceholder: true, format: () => '', messages: {} }
            })
            : w(NEQuestionAudit, questionProps);
        const pearsonvueQuiz = (inreview) => inreview
            ? w(PearsonVueReview, {
                quizstore,
                getQuestions,
                onFinish,
                filterOn,
                checkFor,
                onReview,
                isaudit: false,
                localizedBundle: { isPlaceholder: true, format: () => '', messages: {} }
            })
            : w(NEQuestionPearsonVue, questionProps);
        const qfAudit = (inreview) => inreview
            ? w(PretestReview, {
                quizstore,
                getQuestions,
                onFinish,
                filterOn,
                checkFor,
                onReview,
                isaudit: false,
                localizedBundle: { isPlaceholder: true, format: () => '', messages: {} }
            })
            : w(NEQuestionAudit, questionProps);
        const pretestQuiz = () => w(NEQuestionPretest, questionProps);
        switch (quizkind) {
            case 'pretest':
                return pretestQuiz();
            case 'posttest':
            case 'practice':
                switch (progression) {
                    case 'pearson-vue':
                        return isaudit ? pearsonvueAudit(inreview) : pearsonvueQuiz(inreview);
                    default:
                        return isaudit ? qfAudit(inreview) : w(NumericEntryBase, questionProps);
                }
            default:
                return w(NumericEntryBase, questionProps);
        }
    }
    stateProperties(properties) {
        const { quizstore } = properties;
        const { get, path } = quizstore;
        if (!this._propsInited) {
            const paths = [['quiz'], ['progression']];
            const invalidatePaths = paths.map((path) => quizstore.path(path.join('/')));
            const handle = quizstore.onChange(invalidatePaths, () => this.invalidate());
            this.own({
                destroy: () => {
                    handle.remove();
                }
            });
            this._propsInited = true;
        }
        properties.quizkind = get(path('quiz')).kind;
        properties.progression = get(path('progression'));
        return properties;
    }
}
__decorate([
    beforeProperties(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Object)
], NumericEntry.prototype, "stateProperties", null);
export default NumericEntry;
